/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qrresultalt2Inputs */

const en_qrresultalt2 = /** @type {(inputs: Qrresultalt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generated QR code`)
};

const de_qrresultalt2 = /** @type {(inputs: Qrresultalt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellter QR-Code`)
};

/**
* | output |
* | --- |
* | "Generated QR code" |
*
* @param {Qrresultalt2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const qrresultalt2 = /** @type {((inputs?: Qrresultalt2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qrresultalt2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_qrresultalt2(inputs)
	return de_qrresultalt2(inputs)
});
export { qrresultalt2 as "qrResultAlt" }